export default "__VITE_ASSET__BJgoqW$b__"